import { Route, Routes } from "react-router-dom";
import Home from "../Page/Home/Home";
import About from "../Page/About/About";
import Service from "../Page/Service/Service";
import Contact from "../Page/Contact/Contact";
import Career from "../Page/Career/Career";
import PrivacyPolicy from "../Page/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "../Page/TermsOfService/TermsOfService";
import Portfolio from "../Page/Portfolio/Portfolio";
import ErrorPage from "../Page/404/error";


const AllRoute = () => {
    return (
        <div className="overflow-hidden">
            <Routes>
                {/* Home Page */}
                <Route path="/" element={<Home />} />
                <Route path="/About" element={<About />} />
                <Route path="/Service" element={<Service />} />
                <Route path="/Career" element={<Career />} />
                <Route path="/Contact" element={<Contact />} />
                <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
                <Route path="/TermsOfService" element={<TermsOfService />} />
                <Route path="/Portfolio" element={<Portfolio />} />
                {/* Catch-all route for 404 page */}
                <Route path="*" element={<ErrorPage />} />
            </Routes>
        </div>
    );
};

export default AllRoute;
